import React from "react";

const doesNothing = () => {};

const DeleteStatusButton = ({ onClick = doesNothing }) => (
  <a className="action waves-effect borderless" onClick={onClick}>
    <i className="material-icons">delete</i>
  </a>
);

const StatusItem = ({
  id,
  name = "",
  deleted,
  even = false,
  fixed = false,
  onDelete = doesNothing,
}) => {
  if (deleted === true) {
    return null;
  }
  const doStatusDelete = () => {
    onDelete(id);
  };
  return (
    <React.Fragment>
      <tr className={`${even ? "even" : "odd"}`}>
        <td>{name}</td>
        <td className="text-center hides-content-to-operators">
          {fixed === true ? null : (
            <DeleteStatusButton onClick={doStatusDelete} />
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};
const StatussList = ({
  items = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
}) => (
  <table className="table">
    <thead>
      <tr>
        <th>NON-BLOCK STATUS</th>
        <th className="text-center">ACTIONS</th>
      </tr>
    </thead>
    <tbody>
      {items
        .filter(({ deleted }) => deleted !== true)
        .map(({ __id, ...client }, index) => (
          <StatusItem
            id={__id}
            key={__id}
            {...client}
            even={(index + 1) % 2 === 0}
            onDelete={() => onDelete(__id)}
            onEdit={() => onEdit(__id)}
          />
        ))}
    </tbody>
  </table>
);
export default StatussList;
